import { PickingPicker } from "../../components/picking-picker.tsx";

export function ReceiptList() {
  return (
    <PickingPicker
      workflow="receipt"
      title="Goods Receipt"
      accent="blue"
      placeholder="e.g. PMWH/IN/00030"
    />
  );
}
